import {
  MetricHeaderLeft,
  MetricHeaderMid,
  MetricHeaderRight,
  MetricHeaderWrapper,
} from "../../components/Headers/Atom"
import { HeaderInfoNav } from "../../components/Headers/Reusable"
import { useNavigate } from "react-router-dom"
import { ProvidersHeaderGeneralDropdownFilter } from "../../components/Dropdown/ProvidersHeaderDropdownFilter"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import DownloadIcon from "@mui/icons-material/Download"
import { DashboardPaper } from "../Dashboard/Old/Atom"
import {
  Box,
  Button,
  IconButton,
  Paper,
  Typography,
  styled,
} from "@mui/material"
import { useEffect, useMemo } from "react"
import { useSelector } from "react-redux"
import {
  setMaevaSelectedGroupsNoAll,
  setMaevaSelectedPractices,
  setMaevaSelectedPracticesNoAll,
  setMaevaSelectedRegionsNoAll,
} from "../../redux/slices/metricSlice"
import {
  setSelectedStatus,
  setSelectedProvider,
  setSelectedYear,
  setSelectedMonth,
  setSelectedMemo,
  setMonthList,
  setSelectedSummaryMemo,
} from "../../redux/slices/doctorCompensationSlice"
import ProvidersHeaderSearchDropdownFilter from "../../components/Dropdown/ProvidersHeaderDropdownFilter/ProvidersHeaderSearchDropdownFilter"
import MonthSelectDropdown from "./MultiSelectDropdown"
import ExportPdfCsv from "../../components/Button/ExportPdfCsv"
import { TabList } from "@mui/lab"
import { permissions } from "../../../config/constants"

type headerProps = {
  name: string
  handleDownload?: any
  rows?: any
  setOpen: any
  reportingTab?: any
}

type navigationProps = {
  data: {
    label: string
    value: any
  }[]
}

export const HuddleHeader = (props: headerProps) => {
  const { name, handleDownload, rows, setOpen, reportingTab } = props
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const loading = useAppSelector((state) => state.app.loading)

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  const selectedDoctorCompensationTab = useSelector((state: any) => {
    return state.doctorCompensation.selectedDoctorCompensationTab
  })

  const huddleGroups = useSelector((state: any) => {
    return state.metric.maevaGroups
  })

  const huddleRegions = useSelector((state: any) => {
    return state.metric.maevaRegions
  })

  const maevaPractices = useSelector((state: any) => {
    return state.metric.maevaPractices
  })

  const maevaSelectedGroupsNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedGroupsNoAll
  })

  const selectedHuddleGroup = maevaSelectedGroupsNoAll?.[0]

  const maevaSelectedRegionsNoAll = useSelector((state: any) => {
    return state.metric.maevaSelectedRegionsNoAll
  })
  const maevaSelectedRegion = useSelector((state: any) => {
    return state.metric.maevaSelectedRegionsNoAll?.[0]
  })

  const selectedHuddleRegion = maevaSelectedRegionsNoAll?.[0]

  const maevaSelectedPractice = useSelector((state: any) => {
    return state.metric.maevaSelectedPractices?.[0]
  })

  const providerList: any = useSelector(
    (state: any) => state.doctorCompensation.providerList,
  )
  const selectedProvider = useSelector((state: any) => {
    return state.doctorCompensation.selectedProvider[0]
  })
  const statusList: any = useSelector(
    (state: any) => state.doctorCompensation.statusList,
  )
  const selectedStatus = useSelector((state: any) => {
    return state.doctorCompensation.selectedStatus[0]
  })
  const yearList: any = useSelector(
    (state: any) => state.doctorCompensation.yearList,
  )
  const selectedYear = useSelector((state: any) => {
    return state.doctorCompensation.selectedYear[0]
  })
  const monthList: any = useSelector(
    (state: any) => state.doctorCompensation.monthList,
  )
  const selectedMonth = useSelector((state: any) => {
    return state.doctorCompensation.selectedMonth
  })
  const summaryMemoList: any = useSelector(
    (state: any) => state.doctorCompensation.summaryMemoList,
  )
  const selectedSummaryMemo = useSelector((state: any) => {
    return state.doctorCompensation.selectedSummaryMemo[0]
  })
  const qboMemoList: any = useSelector(
    (state: any) => state.doctorCompensation.qboMemoList,
  )
  // const selectedMemo = useSelector((state: any) => {
  //   return state.doctorCompensation.selectedMemo[0]
  // })

  const handleGroupFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedGroupsNoAll([value]))
    dispatch(setMaevaSelectedRegionsNoAll([]))
    dispatch(setMaevaSelectedPractices([]))

    // for compensation
    dispatch(setSelectedProvider([]))
    dispatch(setSelectedStatus([]))

    // for reporting
    dispatch(setSelectedYear([]))
    // dispatch(setMonthList([]))
    dispatch(setSelectedMonth([]))
    // dispatch(setSelectedMemo([]))
    // dispatch(setSelectedSummaryMemo([]))
  }

  const handleRegionFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedRegionsNoAll([value]))

    if (selectedDoctorCompensationTab?.id == "reporting") {
      // making empty

      if (maevaSelectedPractice?.label == "All") {
        dispatch(setMaevaSelectedPractices([]))
      }
      dispatch(setMaevaSelectedPractices([]))
    } else {
      // making default all for offices
      dispatch(
        setMaevaSelectedPractices([
          { label: "All", name: "All", practice_sk: "all" },
        ]),
      )
    }

    // for compensation
    dispatch(setSelectedProvider([{ label: "All", name: "All" }]))
    dispatch(setSelectedStatus([{ label: "All", name: "All" }]))

    // for reporting
    dispatch(setSelectedYear([]))
    // dispatch(setMonthList([]))
    dispatch(setSelectedMonth([]))
    // dispatch(setSelectedMemo([]))
    // dispatch(setSelectedSummaryMemo([]))
  }

  const handleOfficeFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setMaevaSelectedPractices([value]))

    // for compensation
    dispatch(setSelectedProvider([{ label: "All", name: "All" }]))
    dispatch(setSelectedStatus([{ label: "All", name: "All" }]))

    // for reporting
    dispatch(setSelectedYear([]))
    // dispatch(setMonthList([]))
    // dispatch(setSelectedMonth([]))
    // dispatch(setSelectedMemo([]))
    // dispatch(setSelectedSummaryMemo([]))
  }

  const handleProviderFilter = (event: any) => {
    const {
      target: { value },
    } = event
    dispatch(setSelectedProvider([value]))
    dispatch(setSelectedStatus([{ label: "All", name: "All" }]))
  }

  const handleStatusFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setSelectedStatus([value]))
  }

  const handleYearFilter = (event: any) => {
    const {
      target: { value },
    } = event

    dispatch(setSelectedYear([value]))
    // dispatch(
    //   setMonthList([
    //     { label: "January", name: "1" },
    //     { label: "February", name: "2" },
    //     { label: "March", name: "3" },
    //     { label: "April", name: "4" },
    //     { label: "May", name: "5" },
    //     { label: "June", name: "6" },
    //     { label: "July", name: "7" },
    //     { label: "August", name: "8" },
    //     { label: "September", name: "9" },
    //     { label: "October", name: "10" },
    //     { label: "November", name: "11" },
    //     { label: "December", name: "12" },
    //   ]),
    // )
    // dispatch(setSelectedMonth([]))

    // !selectedMemo && dispatch(setSelectedMemo([{ label: "All", name: "all" }]))
    // !selectedSummaryMemo &&
    //   dispatch(setSelectedSummaryMemo([{ label: "All", name: "all" }]))
  }

  const handleMonthFilter = (event: any) => {
    // const {
    //   target: { value },
    // } = event
    // console.log("dhgf", value)
    // dispatch(setSelectedMonth([value]))
    // !selectedMemo && dispatch(setSelectedMemo([{ label: "All", name: "all" }]))
    // !selectedSummaryMemo &&
    //   dispatch(setSelectedSummaryMemo([{ label: "All", name: "all" }]))
  }

  // const handleMemoFilter = (event: any) => {
  //   const {
  //     target: { value },
  //   } = event

  //   reportingTab == "1"
  //     ? dispatch(setSelectedSummaryMemo([value]))
  //     : dispatch(setSelectedMemo([value]))
  // }

  const handleClickBack = () => {
    navigate(-1)
  }

  useEffect(() => {}, [maevaSelectedPractice])

  const styles = {
    marginLeft: "1rem",
  }
  return (
    <MetricHeaderWrapper sx={{ justifyContent: "flex-start" }}>
      <MetricHeaderLeft>
        <HeaderInfoNav
          name={name}
          handleClickBack={handleClickBack}
          isBack={false}
        />
      </MetricHeaderLeft>

      <MetricHeaderMid>
        <Box sx={{ display: "flex" }}>
          <ProvidersHeaderGeneralDropdownFilter
            id={1}
            key={"huddle-filter-1"}
            disabled={loading}
            handleFilter={handleGroupFilter}
            filterData={huddleGroups}
            headerLabel="Group Name"
            value={selectedHuddleGroup}
            placeholder="Select a Group"
          />
          <ProvidersHeaderGeneralDropdownFilter
            id={2}
            key={"huddle-filter-2"}
            disabled={!selectedHuddleGroup || loading}
            handleFilter={handleRegionFilter}
            filterData={huddleRegions}
            headerLabel="Regions"
            value={selectedHuddleRegion}
            placeholder="Select a Region"
          />
          <ProvidersHeaderGeneralDropdownFilter
            id={3}
            key={"huddle-filter-3"}
            disabled={!selectedHuddleRegion || loading}
            handleFilter={handleOfficeFilter}
            filterData={maevaPractices}
            headerLabel="Office"
            value={maevaSelectedPractice}
            placeholder="Select an Office"
          />
        </Box>
        <Box sx={{ display: "flex" }}>
          {/* {selectedDoctorCompensationTab?.id == "compensation" ? ( */}
          <ProvidersHeaderSearchDropdownFilter
            id={4}
            key={"huddle-filter-4"}
            disabled={!maevaSelectedPractice || loading}
            handleFilter={handleProviderFilter}
            filterData={providerList}
            headerLabel="Doctor"
            value={selectedProvider}
            placeholder="Select a Doctor"
          />
          {/* ) : null */}
          {selectedDoctorCompensationTab?.id == "compensation" ? (
            <ProvidersHeaderGeneralDropdownFilter
              id={5}
              key={"huddle-filter-5"}
              disabled={!selectedProvider || loading}
              handleFilter={handleStatusFilter}
              filterData={statusList}
              headerLabel="Status"
              value={selectedStatus}
              placeholder="Select a Status"
            />
          ) : null}
          {selectedDoctorCompensationTab?.id == "reporting" ? (
            <ProvidersHeaderGeneralDropdownFilter
              id={6}
              key={"huddle-filter-6"}
              disabled={!maevaSelectedPractice || loading}
              handleFilter={handleYearFilter}
              filterData={yearList}
              headerLabel="Year"
              value={selectedYear}
              placeholder="Select a Year"
            />
          ) : null}
          {selectedDoctorCompensationTab?.id == "reporting" ? (
            // <ProvidersHeaderGeneralDropdownFilter
            //   id={7}
            //   key={"huddle-filter-7"}
            //   disabled={!selectedYear || loading}
            //   handleFilter={handleMonthFilter}
            //   filterData={monthList}
            //   headerLabel="Month"
            //   value={selectedMonth}
            //   placeholder="Select a Month"
            // />
            <MonthSelectDropdown
              disabled={!selectedYear || loading}
              handleFilter={handleMonthFilter}
            />
          ) : null}
          {/* {selectedDoctorCompensationTab?.id == "reporting" ? (
            <ProvidersHeaderGeneralDropdownFilter
              id={8}
              key={"huddle-filter-8"}
              disabled={
                !Boolean(selectedMonth.length > 0) || !selectedYear || loading
              }
              handleFilter={handleMemoFilter}
              filterData={reportingTab == "1" ? summaryMemoList : qboMemoList}
              headerLabel="Doctor"
              value={reportingTab == "1" ? selectedSummaryMemo : selectedMemo}
              placeholder="Select a Doctor"
            />
          ) : null} */}
        </Box>
      </MetricHeaderMid>
      <MetricHeaderRight>
        {selectedDoctorCompensationTab?.id == "compensation" &&
        maevaSelectedRegion &&
        maevaSelectedPractice?.label !== "All" &&
        allPerms.includes(permissions?.CREATE_CONTRACT) ? (
          <Button
            sx={{
              backgroundColor: "#1A428A",
              "&:hover": { backgroundColor: "#1A428A" },
              display: "flex",
              color: "#FFFFFF",
              height: "40px",
            }}
            onClick={() => setOpen(true)}
          >
            {/* <IconButton disableRipple sx={{ color: "#FFFFFF", padding: "0", fontSize: 14 }}>
            <DownloadIcon />
          </IconButton> */}
            <Typography marginLeft={1} fontSize={14}>
              + New contract
            </Typography>
          </Button>
        ) : null}
        {(selectedDoctorCompensationTab?.id == "compensation" &&
          maevaSelectedPractice) ||
        (selectedDoctorCompensationTab?.id == "reporting" && selectedMonth) ? (
          // <Button
          //   sx={{
          //     height: "40px",
          //     backgroundColor: "#1A428A",
          //     "&:hover": { backgroundColor: "#1A428A" },
          //     display: "flex",
          //     color: "#FFFFFF",
          //     marginLeft: "1rem",
          //   }}
          //   onClick={handleDownload}
          // >
          //   <IconButton
          //     disableRipple
          //     sx={{ color: "#FFFFFF", padding: "0", fontSize: 14 }}
          //   >
          //     <DownloadIcon />
          //   </IconButton>
          //   <Typography marginLeft={1} fontSize={14}>
          //     Download
          //   </Typography>
          // </Button>
          <ExportPdfCsv handleDownload={handleDownload} styleProps={styles} />
        ) : null}
      </MetricHeaderRight>
    </MetricHeaderWrapper>
  )
}

export const StyledTabsList = styled(TabList)({
  // height: "5vh",
  color: "#706F70",
  marginLeft: "29px",
  ".MuiTab-root": {
    minWidth: "0px",
    color: "#706F70",
    textTransform: "capitalize",
    fontSize: "16px",
    fontFamily: "Poppins",
    alignItems: "flex-start",
    // padding: 0,
    paddingLeft: 0,
  },
  ".MuiTab-root.Mui-selected": {
    color: "#000000",
    fontWeight: "600",
  },
  ".MuiTabs-indicator": {
    backgroundColor: "#3C77EF",
    maxWidth: "34px",
    height: "4px",
  },
})

export const NavigationAssistant = ({ data }: navigationProps) => {
  const message = useMemo(() => {
    let message = "Select filters"
    for (let item of data) {
      if (!item.value) {
        return item.label
      }
    }
    return message
  }, [data])

  return (
    <DashboardPaper
      sx={{ mb: "10px", justifyContent: "center", alignItems: "center" }}
    >
      {message}
    </DashboardPaper>
  )
}

export const TableWrapperPaper = styled(Paper)({
  // margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  height: "fit-content",
  width: "fit-content",
  // flex: 1,
  // flexGrow: 1,
})

export const TableWrapperPaperOld = styled(Paper)({
  // margin: "0px 24px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  boxShadow: "0px 2px 8px #00000022",
  // height: "fit-content",
  // width: "fit-content",
  flex: 1,
  flexGrow: 1,
})

//Unused Code

// Typography Table Header

{
  /* <Typography
                  sx={{
                    pl: "25px",
                    py: "8px",
                    fontWeight: "bold",
                    backgroundColor: "#3C77EF",
                    color: "#fff",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                  }}
                >
                  Daily Production Goal
                </Typography> */
}

// Huddle Table Old

{
  /* <HuddleTable
                  columns={columnSet1}
                  data={huddleData?.yesterday?.providers || []}
                  enableEditing={enableEditing}
                  blurHandler={openDialog}
                /> */
}
